module.exports = __webpack_public_path__ + "a30deb26b4eb1521433021e326cbcc2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/logo-jhipster.png
// module id = 335
// module chunks = 0